/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActionRule } from './ActionRule';
import {
    ActionRuleFromJSON,
    ActionRuleFromJSONTyped,
    ActionRuleToJSON,
    ActionRuleToJSONTyped,
} from './ActionRule';
import type { ParamSpecSchema } from './ParamSpecSchema';
import {
    ParamSpecSchemaFromJSON,
    ParamSpecSchemaFromJSONTyped,
    ParamSpecSchemaToJSON,
    ParamSpecSchemaToJSONTyped,
} from './ParamSpecSchema';

/**
 * An action configured on a transition, with its ordered rules and its param spec.
 * 
 * ``is_registered`` matters: a config outlives the action it points at, and the engine logs
 * and skips those rather than failing. The editor has to be able to show that.
 * @export
 * @interface TransitionAction
 */
export interface TransitionAction {
    /**
     * 
     * @type {string}
     * @memberof TransitionAction
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionAction
     */
    actionName: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionAction
     */
    readonly title: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransitionAction
     */
    readonly isRegistered: boolean;
    /**
     * Position of the action on the transition, used for ordering.
     * @type {number}
     * @memberof TransitionAction
     */
    position?: number;
    /**
     * 
     * @type {Array<ParamSpecSchema>}
     * @memberof TransitionAction
     */
    readonly paramSpec: Array<ParamSpecSchema>;
    /**
     * 
     * @type {Array<ActionRule>}
     * @memberof TransitionAction
     */
    readonly rules: Array<ActionRule>;
}

/**
 * Check if a given object implements the TransitionAction interface.
 */
export function instanceOfTransitionAction(value: object): value is TransitionAction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('actionName' in (value as Record<string, any>)) && !('action_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionName'] === undefined && (value as Record<string, any>)['action_name'] === undefined)) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if ((!('isRegistered' in (value as Record<string, any>)) && !('is_registered' in (value as Record<string, any>))) || ((value as Record<string, any>)['isRegistered'] === undefined && (value as Record<string, any>)['is_registered'] === undefined)) return false;
    if ((!('paramSpec' in (value as Record<string, any>)) && !('param_spec' in (value as Record<string, any>))) || ((value as Record<string, any>)['paramSpec'] === undefined && (value as Record<string, any>)['param_spec'] === undefined)) return false;
    if (!('rules' in value) || value['rules'] === undefined) return false;
    return true;
}

export function TransitionActionFromJSON(json: any): TransitionAction {
    return TransitionActionFromJSONTyped(json, false);
}

export function TransitionActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionAction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'actionName': json['action_name'],
        'title': json['title'],
        'isRegistered': json['is_registered'],
        'position': json['position'] == null ? undefined : json['position'],
        'paramSpec': ((json['param_spec'] as Array<any>).map(ParamSpecSchemaFromJSON)),
        'rules': ((json['rules'] as Array<any>).map(ActionRuleFromJSON)),
    };
}

export function TransitionActionToJSON(json: any): TransitionAction {
    return TransitionActionToJSONTyped(json, false);
}

export function TransitionActionToJSONTyped(value?: Omit<TransitionAction, 'id'|'title'|'isRegistered'|'paramSpec'|'rules'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action_name': value['actionName'],
        'position': value['position'],
    };
}

